import { RemoteGetCellphonesByStatus } from "../../../../data/usecases/cellphone/remote-get-cellphones-by-status";
import { GetCellphonesByStatus } from "../../../../domain/usecases/get-cellphones-by-status";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteGetCellphonesByStatus = (): GetCellphonesByStatus =>
  new RemoteGetCellphonesByStatus(
    makeApiUrl("/cellphones/get-cellphones-by-status"),
    makeAxiosHttpClient()
  );
